export default __webpack_public_path__ + "static/media/deliverit-logo.966587e1.png";